

import { Box, Menu, MenuButton, MenuList, Portal } from '@chakra-ui/react';
import { type MouseEvent, type RefObject, useContext, useEffect, useState } from 'react';

import { type ReferenceMap } from '@rta/rta-blueprint-library';

import { AppContext } from '@r-app/app-context';
import { type ContextMenuList } from './types';
import { contextMenuService } from './context-menu-service';
import { getContextMenuList } from './get-context-menu-list';
import { renderMenu } from './render-menu';
import { useContextMenu } from './use-context-menu';
import { useInteraction } from '@r-services/ui-interactions';

type Props = {
	svg: RefObject<SVGSVGElement>;
	children?: React.ReactElement;
};

export const ContextMenu: React.FC<Props> = ({ svg, children }) => {
	const { controller } = useContext(AppContext);
	const [isOpen, setIsOpen] = useState(false);
	const [position, setPosition] = useState<[number, number]>([0, 0]);
	// const [menuList, setMenuList] = useState<() => React.ReactElement>(getContextMenuList(appState.ui.pointer.context.menuKey));
	const [menuList, setMenuList] = useState<Array<ContextMenuList>>([]);
	const [refMap, setRefMap] = useState<ReferenceMap>(null);

	const [cmData] = useContextMenu();
	const [{ raw, pointer }] = useInteraction(svg);

	useEffect((): void => {
		if (isOpen === true) {
			// appDispatch({
			// 	type: UiActionTypes.SetContextMenu,
			// 	payload: {
			// 		kitchen: controller.kitchen,
			// 		context: appState.ui.pointer.context,
			// 		position: appState.ui.pointer.relative.clone() as Vertex2
			// 	}
			// })
			setPosition([raw.x, raw.y]);
			let tRefMap = null;
			if (controller && cmData.context.id !== null) {
				tRefMap = controller.kitchen.getReferenceMap(cmData.context.id);
				setRefMap(tRefMap);
			}

			setMenuList(getContextMenuList({
				data: cmData,
				refMap: tRefMap,
				displayMode: controller.navigation.displayMode,
				controller
			}));
		} else {
			setMenuList([]);
			setRefMap(null);
		}
	}, [isOpen, controller]);

	// useEffect(() => {
	// 	// const e = svg.current;
	// 	appDispatch({
	// 		type: UiActionTypes.SetSvgElement,
	// 		payload: svg.current
	// 	});
	// }, [svg]);

	// when the trigger is right clicked,
	// we want to add a menu in our context or update it if it already exists
	return controller.options.contextMenu ? (
		<Box
			display={'contents'}
			zIndex={26}
			h="100%"
			w="100%"
			// onMouseMove={(e) => {
			// appDispatch({
			// 	type: UiActionTypes.PointerPosition,
			// 	payload: new Vertex2({ dataIn: {
			// 		x: e.clientX,
			// 		y: e.clientY
			// 	}})
			// });
			// }}
			onClick={() => {
				setIsOpen(false);
				contextMenuService.setPosition({ x: 0, y: 0 });
				contextMenuService.freezeContext(false);
			}}
			onContextMenu={(event: MouseEvent) => {
				if (isOpen) setIsOpen(false);

				// Prevent browser menu and show custom context menu
				event.preventDefault();
				contextMenuService.setPosition(pointer);
				contextMenuService.freezeContext(true);
				setIsOpen(true);
			}}
		>
			{children}

			<Portal>
				<Menu isLazy lazyBehavior="unmount" isOpen={isOpen} gutter={0}>
					<MenuButton
						tabIndex={-1}
						w={1}
						h={1}
						style={{
							position: 'absolute',
							left: position[0] - 5,
							top: position[1] - 15,
							cursor: 'default',
							pointerEvents: 'none'
						}}
					/>
					<MenuList>
						<div
							style={{ position: 'relative', width: '100%', height: '100%', padding: '2px 5px 2px 5px' }}
							onMouseLeave={() => {
								setIsOpen(false);
								contextMenuService.freezeContext(false);
								contextMenuService.setPosition({ x: 0, y: 0 });
							}}
						>
							{renderMenu({
								menuList,
								state: {
									context: cmData.context,
									position: cmData.relative,
									refMap,
									controller
								}
							})}
						</div>
					</MenuList>
				</Menu>
			</Portal>
		</Box>
	) : (
		<>{children}</>
	);
};
